import DialogComponent from "components/Dialog";

export default class ConfirmDialog extends DialogComponent {

    show({ title, message }, hideCb, cancelCb) {
        this.dialogSaveLabel = "main.confirm";
        this.dialogTitle = title || "";
        this.message = message || "";
        this.ccb = cancelCb;
        this.hidCb = hideCb;

        super.show();
    }

    async save() {
        this.hide();

        if (this.hidCb?.apply)
            this.hidCb();
    }

    hide() {
        if (this.ccb?.apply)
            this.ccb();
        super.hide();
    }

    renderContent() {
        return (
            <div className="content text p1 breakSpaces">{this.message}</div>
        );
    }

}

